import {IComponentOptions} from 'angular';
import {getTSKulturartValues, kulturartPrefix, TSKulturart} from '../../../models/enums/TSKulturart';
import {getTSSchadenArtValues, schadenartPrefix, TSSchadenArt} from '../../../models/enums/TSSchadenArt';
import {getTSSchadenObjektValues, TSSchadenObjektTyp} from '../../../models/enums/TSSchadenObjekt';
import TSSchaden from '../../../models/TSSchaden';
import {MapController} from '../../dialog/MapController';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

declare let require: any;
declare let angular: any;
let mapTemplate = require('../../dialog/mapTemplate.html');
require('./dv-schaden.scss');

export class SchadenComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        schaden: '=',
        schadenfallId: '<',
        readonly: '<',
        showGeschaetztekosten: '<',
    };
    template = require('./dv-schaden.html');
    controller = DvSchadenController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};

}

export class DvSchadenController {

    schaden: TSSchaden;
    schadenfallId: string;

    options: any;
    details: any;
    readonly: boolean;
    showGeschaetztekosten: boolean;
    formschaden: IFormController;
    parentForm: IFormController;

    currentYear: number = new Date().getFullYear();

    static $inject = ['DvDialog', '$log', 'SchadenfallModelManager', '$scope', '$translate', 'RoleUtilService'];

    /* @ngInject */
    constructor(private dvDialog: DvDialog, private $log: ILogService,
                private schadenfallModelManager: SchadenfallModelManager, private $scope: IScope,
                private $translate: ITranslateService,
    ) {
    }

    $onInit() {

        if (!this.schadenfallId) {
            console.warn('No schadenfallId!');
            let schadenfall = this.schadenfallModelManager.getSchadenfall();
            this.schadenfallId = schadenfall ? schadenfall.id : '';
        }

        /*Options for autocomplete*/
        this.options = {
            types: 'geocode',
            country: 'ch',
        };

        /*set marker position if autocomplete has changed*/
        this.$scope.$watch(() => {
            return this.details;
        }, (newValue, oldValue) => {
            if ((newValue !== oldValue)) {
                this.getModel().schadenDatenFS.mapLatitude = newValue.geometry.location.lat();
                this.getModel().schadenDatenFS.mapLongitude = newValue.geometry.location.lng();
            }
        });
    }

    private getModel(): TSSchaden {
        return this.schaden;
    }

    public getTSSchadenArtValues(): Array<TSSchadenArt> {
        return getTSSchadenArtValues();
    }

    public getTSSchadenObjektValues(): Array<TSSchadenObjektTyp> {
        return getTSSchadenObjektValues();
    }

    public getTSKulturartValues(): Array<TSKulturart> {
        return getTSKulturartValues();
    }

    public showForSchadenObjekt(what: string): boolean {
        let schaden: TSSchaden = this.getModel();
        if (schaden) {
            return schaden.propertyExistsForSchadenObjektType(what);
        }
        return false;
    }

    public addPosition() {
        let lat: string = '';
        let lon: string = '';
        let schaden: TSSchaden = this.getModel();
        if (schaden && schaden.schadenDatenFS) {
            if (schaden.schadenDatenFS.mapLatitude) {
                lat = schaden.schadenDatenFS.mapLatitude.toString();
            }
            if (schaden.schadenDatenFS.mapLongitude) {
                lon = schaden.schadenDatenFS.mapLongitude.toString();
            }

            this.dvDialog.showMapDialog(mapTemplate, MapController, {
                lat: lat,
                lon: lon,
                readonly: this.readonly,
            }).then((response) => {
                if (response) {
                    if (!this.readonly && schaden && schaden.schadenDatenFS) {
                        schaden.schadenDatenFS.mapLatitude = response.lat;
                        schaden.schadenDatenFS.mapLongitude = response.lon;
                    }
                }
            }).catch(() => {
                // do nothing
            });
        }
    }

    public getSchadenArtPrefix(): string {
        return schadenartPrefix();
    }

    public translateSchadenArt(art: TSSchadenArt): string {
        let prefix = this.getSchadenArtPrefix();
        return this.$translate.instant(prefix + TSSchadenArt[art])
    }

    public translateKulturart(art: TSKulturart): string {
        let prefix = kulturartPrefix();
        return this.$translate.instant(prefix + TSKulturart[art])
    }

    public showAndere() {
        return this.getModel().schadenDatenFS.schadenArt === TSSchadenArt.ANDERE;
    }

    public isWald() {
        return this.getModel().schadenDatenFS.schadenObjekt === TSSchadenObjektTyp.WALD;
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-schaden/dv-schaden.ts